/**
 * @description: 商品套餐盈利明细报表
 * @author: lyr
*/
<template>
    <div class="goodspackage-detail-report">
        <div class="red-tip">注：当天营业数据就只能单个营业日，历史数据支持一个月内的数据查询</div>
        <div class="list">
            <el-form :inline="true" size="small" :model="list_form">
                <el-form-item label="时间">
                    <div class="clearfix" ref="list_date">
                        <el-col :span="11">
                            <el-input placeholder="开始时间" v-model="list_form.start_time"></el-input>
                        </el-col>
                        <el-col class="el-line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-input placeholder="结束时间" v-model="list_form.end_time"></el-input>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="门店">
                    <el-select v-model="list_form.shop_id" filterable  placeholder="请选择门店" @change="changeShop($event)">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="包厢区域">
                    <el-input placeholder="请选择包厢区域" v-model="room_area_str" readonly @click.native="openRoomAreaPop"></el-input>
                </el-form-item>
                <el-form-item label="包厢类型">
                    <el-select v-model="list_form.room_type" filterable  placeholder="请选择包厢类型">
                        <el-option v-for="item in room_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="包厢号">
                    <el-select v-model="list_form.room_id" filterable clearable placeholder="请选择包厢" :disabled="list_form.shop_id==''">
                        <el-option v-for="item in room_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="支付类型">
                    <el-input placeholder="请选择支付类型" v-model="pay_platform_str" readonly @click.native="openPayPlatformPop"></el-input>
                </el-form-item>
                <el-form-item label="商品套餐类型">
                    <el-input placeholder="请选择商品套餐类型" v-model="goods_type_str" readonly @click.native="openGoodsTypePop"></el-input>
                </el-form-item>
                <el-form-item label="商品套餐名称">
                    <el-input v-model="list_form.package_name" clearable placeholder="请输入商品套餐名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input placeholder="请输入预订人姓名" v-model="list_form.book_admin_name">
                        <el-select class="el-slot-select" v-model="list_form.book_admin_type" slot="prepend" placeholder="请选择">
                            <el-option label="员工" value="1"></el-option>
                            <el-option label="艺人" value="2"></el-option>
                        </el-select>
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="listQuery">查询</el-button>
                    <el-button @click="listExport">导出</el-button>
                </el-form-item>
            </el-form>
            <div class="total-row">
                <div class="item">折后总额：{{actual_total}}</div>
                <div class="item">成本总额：{{buying_price_total}}</div>
                <div class="item">利润总额：{{profit_price_total}}</div>
            </div>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}"
                :data="list_table">
                <el-table-column prop="room_name" label="包厢号"></el-table-column>
                <el-table-column prop="room_type_name" label="包厢类型"></el-table-column>
                <el-table-column prop="room_area_name" label="包厢区域"></el-table-column>
                <el-table-column prop="bill_no" label="账单号" width="150"></el-table-column>
                <el-table-column prop="book_admin_name" label="预定员工"></el-table-column>
                <el-table-column prop="order_id" label="订单编号" width="160"></el-table-column>
                <el-table-column prop="pay_platform_name" label="支付类型"></el-table-column>
                <el-table-column prop="create_time" label="支付时间" width="160"></el-table-column>
                <el-table-column prop="goods_type_name" label="商品套餐类型"></el-table-column>
                <el-table-column prop="package_name" label="商品套餐名称" width="150"></el-table-column>
                <el-table-column prop="package_unit_name" label="单位"></el-table-column>
                <el-table-column prop="price" label="单价"></el-table-column>
                <el-table-column prop="quantity" label="净销售数量"></el-table-column>
                <el-table-column prop="actual" label="折后单价"></el-table-column>
                <el-table-column prop="actual_total" label="折后总额"></el-table-column>
                <el-table-column prop="buying_price" label="成本单价"></el-table-column>
                <el-table-column prop="buying_price_total" label="成本总额"></el-table-column>
                <el-table-column prop="profit_price_total" label="利润总额"></el-table-column>
                <el-table-column prop="profit_margin" label="利润率"></el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :page-size="GLOBAL.PAGESIZE"
                :current-page.sync="list_page"
                :total="list_total"
                @current-change="getList">
            </el-pagination>
        </div>
        <!-- 包厢区域选择 -->
        <div class="room-area-pop" ref="room_area_pop">
            <div class="checkbox-wrapper">
                <el-checkbox v-model="checkAllRoomArea" @change="handleCheckAllRoomAreaChange">全选</el-checkbox>
                <el-checkbox-group v-model="list_form.area_ids" @change="handleCheckRoomAreaChange">
                    <el-checkbox v-for="item in room_area_list" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
                </el-checkbox-group>
            </div> 
        </div>
        <!-- 支付类型选择 -->
        <div class="pay-platform-pop" ref="pay_platform_pop">
            <div class="checkbox-wrapper">
                <el-checkbox v-model="checkAllPayPlatform" @change="handleCheckAllPayPlatformChange">全选</el-checkbox>
                <el-checkbox-group v-model="list_form.pay_platform" @change="handleCheckPayPlatformChange">
                    <el-checkbox v-for="item in pay_platform" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
                </el-checkbox-group>
            </div> 
        </div>
        <!-- 商品套餐类型选择 -->
        <div class="goods-type-pop" ref="goods_type_pop">
            <div class="checkbox-wrapper">
                <el-checkbox v-model="checkAllGoodsType" @change="handleCheckAllGoodsTypeChange">全选</el-checkbox>
                <el-checkbox-group v-model="list_form.goods_type" @change="handleCheckGoodsTypeChange">
                    <el-checkbox v-for="item in goods_type_list" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
                </el-checkbox-group>
            </div> 
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: 'goodspackage-detail-report',
        data() {
            return {
                loading: false,
                shop_list: [],
                room_area_list: [],
                room_list: [],
                room_type_list: [],
                pay_platform: [],
                goods_type_list: [],
                staff_list: [],
                checkAllRoomArea: false,
                checkAllPayPlatform: false,
                checkAllGoodsType: false,
                list_form: {
                    start_time: '',
                    end_time: '',
                    shop_id: '',
                    area_ids: [],
                    room_id: '0',
                    room_type: '0', // 包厢类型 0全部
                    pay_platform: [],
                    goods_type: [],
                    package_name: '',
                    book_admin_name: '',
                    book_admin_type: '1', //1员工 2艺人
				},
				list_table: [],
				list_page: 1,
                list_total: 0,
                actual_total: 0, // 折后总额
                buying_price_total: 0, // 成本总额
                profit_price_total: 0, // 利润总额
            }
        },
        computed: {
            room_area_str() {
                if (this.list_form.area_ids.length == 0) {
                    return ''
                }else if(this.list_form.area_ids.length == this.room_area_list.length) {
                    return '全部'
                }else {
                    let res = []
                    this.list_form.area_ids.forEach(v => {
                        this.room_area_list.forEach(item => {
                            if (item.id == v) {
                                res.push(item.name)
                            }
                        })
                    })
                    return res.join(',')
                }
            },

            pay_platform_str() {
                if (this.list_form.pay_platform.length == 0) {
                    return ''
                }else if(this.list_form.pay_platform.length == this.pay_platform.length) {
                    return '全部'
                }else {
                    let res = []
                    this.list_form.pay_platform.forEach(v => {
                        this.pay_platform.forEach(item => {
                            if (item.id == v) {
                                res.push(item.name)
                            }
                        })
                    })
                    return res.join(',')
                }
            },

            goods_type_str() {
                if (this.list_form.goods_type.length == 0) {
                    return ''
                }else if(this.list_form.goods_type.length == this.goods_type_list.length) {
                    return '全部'
                }else {
                    let res = []
                    this.list_form.goods_type.forEach(v => {
                        this.goods_type_list.forEach(item => {
                            if (item.id == v) {
                                res.push(item.name)
                            }
                        })
                    })
                    return res.join(',')
                }
            },
        },
        mounted: function() {
            // 日期
            this.list_form.start_time = moment().format('YYYY-MM-DD 08:00');
            this.list_form.end_time = moment().add(1, 'day').format('YYYY-MM-DD 08:00');
            this.innitDate();
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.list_form.shop_id = this.shop_list[0].id;
                this.getRoomArea(this.list_form.shop_id)
                this.getRoom(this.list_form.shop_id)
                this.getRoomType(this.list_form.shop_id)
                this.getPayType(this.list_form.shop_id)
                this.getGoodsType()
                this.getStaffList(this.list_form.shop_id)
                this.getList(1);
            })
        },
        methods: {
            // 初始化日期插件
            innitDate: function() {
                const _this = this;
                $(_this.$refs.list_date).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().toDate(),
                    endDate: moment().add(1, 'day').toDate(),
                }, function(start, end, label) {
                    _this.list_form.start_time = start.format('YYYY-MM-DD 08:00');
                    _this.list_form.end_time = end.format('YYYY-MM-DD 08:00');
                });
            },
            // 初始化门店输入框
            getShop: function(resolve) {
                const _this = this;

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取包厢区域
            getRoomArea: function(shop_id) {
                const _this = this;
                Vue.axios.post('Shop/getRoomArea', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.room_area_list = res.data.response.result;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取包厢类型
            getRoomType: function(shop_id) {
                const _this = this;
                Vue.axios.post('PublicData/api_getRoomType', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.room_type_list = res.data.response.result.data;
                        _this.room_type_list.unshift({
                            id: '0',
                            name: '全部'
                        })
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取员工
            getStaffList: function(shop_id) {
                const _this = this;

                Vue.axios.post('user/getSearchList', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.staff_list = res.data.response.result;
                        _this.staff_list.unshift({
                            id: '',
                            name: '全部'
                        });
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取支付类型
            getPayType: function(shop_id) {
                const _this = this;

                Vue.axios.post('Order/getAllPayPlatform', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        let arr = [];
                        for(let [key, value] of Object.entries(res.data.response.data)) {
                            arr.push({id: key, name: value});
                        }
                       _this.pay_platform = arr
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取包厢号
            getRoom: function(shop_id) {
                const _this = this;
                Vue.axios.post('Shop/getAllRoom', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.room_list = res.data.response.result;
                        _this.room_list.unshift({
                            id: '0',
                            name: '全部'
                        })
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取商品套餐类型
            getGoodsType: function() {
                const _this = this;

                Vue.axios.post('PublicData/api_getWaresType', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.goods_type_list = res.data.response.result.data
                        _this.goods_type_list.unshift({
                            id: '0',
                            name: '商品套餐'
                        })
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
           
            getList(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('Report/getWaresSalesDetailList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
                            "start_date": _this.list_form.start_time,
                            "end_date": _this.list_form.end_time,
							"shop_id": _this.list_form.shop_id,
							"area_ids": _this.list_form.area_ids,
                            "room_id": _this.list_form.room_id,
                            "room_type": _this.list_form.room_type, // 包厢类型 0全部
                            "pay_platform": _this.list_form.pay_platform,
                            "goods_type": _this.list_form.goods_type,
                            "package_name": _this.list_form.package_name,
                            "book_admin_name": _this.list_form.book_admin_name,
                            "book_admin_type": _this.list_form.book_admin_type, //1员工 2艺人
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.list_total = Number(res.data.response.result.total)
                            _this.actual_total = res.data.response.result.actual_total
                            _this.buying_price_total = res.data.response.result.buying_price_total
                            _this.profit_price_total = res.data.response.result.profit_price_total
						}
						_this.list_table = res.data.response.result.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},

            changeShop(val) {
                this.list_form.shop_id = val
                if (!!val) {
                    this.list_form.area_ids = []
                    this.list_form.room_id = '0'
                    this.list_form.room_type = '0'
                    this.list_form.pay_platform = []
                    this.list_form.book_admin_name = ''
                 
                    this.getRoomArea(val)
                    this.getRoom(val)
                    this.getRoomType(val)
                    this.getPayType(val)
                    this.getStaffList(val)
                }
            },

            // 打开包厢区域选择弹窗
            openRoomAreaPop() {
                let _this = this
                let c_area_ids = _this.list_form.area_ids
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择包厢区域', true],
                    area: ['450px', ''], // 宽高
                    content: $(_this.$refs.room_area_pop),
                    cancel: function() {
                        _this.list_form.area_ids = c_area_ids
                    }
                }, function() {
                    layer.closeAll()
                }, function() {
                    _this.list_form.area_ids = c_area_ids
                    layer.closeAll()
                });
            },

            // 包厢区域全选
            handleCheckAllRoomAreaChange(val) {
                this.list_form.area_ids = []
                this.checkAllRoomArea = val
                if (val) {
                    this.room_area_list.forEach(item => {
                        this.list_form.area_ids.push(item.id)
                    })
                }
            },

            // 选择包厢区域
            handleCheckRoomAreaChange(val) {
                this.checkAllRoomArea = val.length === this.room_area_list.length
            },

            // 打开支付类型选择弹窗
            openPayPlatformPop() {
                let _this = this
                let c_pay_platform = _this.list_form.pay_platform
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择支付类型', true],
                    area: ['550px', ''], // 宽高
                    content: $(_this.$refs.pay_platform_pop),
                    cancel: function() {
                        _this.list_form.pay_platform = c_pay_platform
                    }
                }, function() {
                    layer.closeAll()
                }, function() {
                    _this.list_form.pay_platform = c_pay_platform
                    layer.closeAll()
                });
            },

            // 支付类型全选
            handleCheckAllPayPlatformChange(val) {
                this.list_form.pay_platform = []
                this.checkAllPayPlatform = val
                if (val) {
                    this.pay_platform.forEach(item => {
                        this.list_form.pay_platform.push(item.id)
                    })
                }
            },

            // 选择支付类型
            handleCheckPayPlatformChange(val) {
                this.checkAllPayPlatform = val.length === this.pay_platform.length
            },

            // 打开商品套餐类型选择弹窗
            openGoodsTypePop() {
                let _this = this
                let c_goods_type = _this.list_form.goods_type
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择商品套餐类型', true],
                    area: ['550px', ''], // 宽高
                    content: $(_this.$refs.goods_type_pop),
                    cancel: function() {
                        _this.list_form.goods_type = c_goods_type
                    }
                }, function() {
                    layer.closeAll()
                }, function() {
                    _this.list_form.goods_type = c_goods_type
                    layer.closeAll()
                });
            },

            // 商品类型全选
            handleCheckAllGoodsTypeChange(val) {
                this.list_form.goods_type = []
                this.checkAllGoodsType = val
                if (val) {
                    this.goods_type_list.forEach(item => {
                        this.list_form.goods_type.push(item.id)
                    })
                }
            },

            // 选择商品类型
            handleCheckGoodsTypeChange(val) {
                this.checkAllGoodsType = val.length === this.goods_type_list.length
            },

			// 查询
			listQuery() {
                this.list_page = 1
				this.getList(this.list_page);
            },
            
            listExport: function() {
                window.location.href = Vue.ctUrl + "Report/waresSalesDetailExport" +
                    "?start_date=" + this.list_form.start_time +
                    "&end_date=" + this.list_form.end_time +
                    "&shop_id=" + this.list_form.shop_id +
                    "&area_ids=" + this.list_form.area_ids +
                    "&room_id=" + this.list_form.room_id +
                    "&room_type=" + this.list_form.room_type +
                    "&pay_platform=" + this.list_form.pay_platform +
                    "&goods_type=" + this.list_form.goods_type +
                    "&package_name=" + this.list_form.package_name +
                    "&book_admin_name=" + this.list_form.book_admin_name +
                    "&book_admin_type=" + this.list_form.book_admin_type;
                layer.msg("导出成功！");
            },
        }
    }
</script>
<style lang="less" scoped>
    .red-tip {
        color: red;
        margin-bottom: 10px;
    }

    .total-row {
        margin-bottom: 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
        .item {
            margin-right: 50px;
        }
    }

    .room-area-pop,
    .pay-platform-pop,
    .goods-type-pop{
        display: none;
        .el-checkbox {
            width: 150px;
            margin-bottom: 10px;
            margin-right: 10px;
        }
    }
</style>